import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { PayRocPage } from './payroc.page';

const routes: Routes = [
  {
    path: '',
    component: PayRocPage,
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PayRocPageRoutingModule {}
